import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=c0bfa2b0&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
import style0 from "./Chat.vue?vue&type=style&index=0&id=c0bfa2b0&prod&lang=scss&scoped=true"
import style1 from "./Chat.vue?vue&type=style&index=1&id=c0bfa2b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bfa2b0",
  null
  
)

export default component.exports